import {
  Pig,
  Badge,
  Grad,
  Emergency,
  Rainy,
  Fun,
} from 'assets/img/GoalCardIcons';

export const getGoalIcon = (type: number, size?: string) => {
  switch (type) {
    case 1:
      return <Pig size={size} />;
    case 2:
      return <Grad size={size} />;
    case 3:
      return <Fun size={size} />;
    case 4:
      return <Badge size={size} />;
    case 5:
      return <Emergency size={size} />;
    case 6:
      return <Rainy size={size} />;
    default:
      return <Badge size={size} />;
  }
};
